import { Card, CardContent } from "./ui/card";
import { Avatar, AvatarFallback } from "./ui/avatar";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Edaan G",
    role: "Product Principal",
    company: "e-commerce platform",
    content: "Decisionr.xyz brought some discipline to how I approach product decisions.",
    avatar: "EG",
    rating: 5
  },
  {
    name: "Mathieu G",
    role: "Founder",
    company: "Superelliptic",
    content: "As a founder, /'dogfooding/' is critical so I used the framework built in decisionr for months before building and launching it.",
    avatar: "MG",
    rating: 5
  },
  {
    name: "B.J. S",
    role: "L&D Director",
    company: "Launchdarkly",
    content: "The tagging is super useful. I've caught myself approaching work and personal decisions very differently when I looked at the analytics that way.",
    avatar: "BS",
    rating: 5
  }
];

export function Testimonials() {
  return (
    <section id="testimonials" className="py-20">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="mb-4">
            Trusted by Decision Makers
          </h2>
          <p className="text-muted-foreground">
            See how professionals are improving their judgment with Decisionr.xyz
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-sm">
              <CardContent className="pt-6">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                <blockquote className="mb-6 leading-relaxed">
                  "{testimonial.content}"
                </blockquote>
                
                <div className="flex items-center">
                  <Avatar className="h-10 w-10 mr-3">
                    <AvatarFallback>{testimonial.avatar}</AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-medium">{testimonial.name}</div>
                    <div className="text-sm text-muted-foreground">
                      {testimonial.role} at {testimonial.company}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}